import React from 'react'
import '../CardList.scss';
import {useDispatch, useSelector} from 'react-redux';
import {deleteBgItem} from '../../../api/common';
import {professionScopes} from '../../../db/datasets/professions';
import {jobContracts} from '../../../db/models/const';
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {openDialog} from '../../../slices/dialog';
import ButtonCircle from '../../Common/ButtonCircle';
import {EditRmJob} from '../../Dialog/Rm/EditJob';
import {selectSelectedRm} from '../../../slices/selected';
import {useTranslation} from 'react-i18next';
import {selectRole} from '../../../slices/profile';

const RmJobs = ({jobs}) => {
    const dispatch = useDispatch();
    const rm = useSelector(selectSelectedRm);
    const role = useSelector(selectRole);
    const editable = role === "company";
    const {t} = useTranslation();

    const addBgItem = (type) => {
        dispatch(openDialog({
            Content: EditRmJob,
            title: t("company_rm_editJob_title"),
            props: {
                docId: rm.id
            },
            closable: true
        }));
    };

    return (
        <div className="card jobs">
            <div className={jobs.length > 0 ? "card__header border" : 'card__header'}>
                <h2>{t("company_rm_job_title")}</h2>
                {editable && <ButtonCircle onClick={() => addBgItem("JOB")}><AddIcon/></ButtonCircle>}
            </div>
            <div className="card__content">
                {jobs.map((job) => (
                    <RmJob
                        key={job.id}
                        job={job}
                        editable={editable}
                        missing={false}
                    />
                ))}
            </div>
        </div>
    );
};

export const RmJob = ({job, editable, docId, missing}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const role = useSelector(selectRole);
    const scopeIds = job?.scopeIds ? job.scopeIds :
        job?.scopeId != null ? [job.scopeId] : [];
    const title = scopeIds.map((id, i) => t(professionScopes[id].label) + (i !== scopeIds.length - 1 ? " | " : ""));
    const months = job?.months || null;
    const contract = job?.contractId != null ? t(jobContracts[job.contractId].label) : "";
    const subtitle = contract + (months ? " | " + t("company_rm_job_months", {months}) : "");
    const desc = job?.description || "";
    const jobTitles = job?.labels || [];
    const optional = job?.importance === 2 ? true : false;
    const rm = useSelector(selectSelectedRm);

    const onUpdateBgItem = () => {
        if (!job || !rm?.id) return;
        dispatch(openDialog({
            Content: EditRmJob,
            title: "Esperienza",
            props: {
                job,
                docId: rm.id
            },
            closable: true
        }));
    };

    const onItemDelete = () => {
        if (!rm?.id) return;
        deleteBgItem(rm.id, job.id, "JOB", role);
    };

    return (
        <div className={missing === true ? "card__item missing" : "card__item"}>
            <div className="card__item__content">
                <h2 className="title">{title}</h2>
                <p className="light">{subtitle}</p>
                <div className="regular" dangerouslySetInnerHTML={{__html: desc}} />
                {jobTitles.length > 0 && <>
                    <label>{t("company_rm_job_suggested")}</label>
                    <div className="suggestedJobList">{jobTitles.map(label => <div className="suggestedJob">{label}</div>)}</div>
                </>}
                {optional && <p>{t("company_rm_optional")}</p>}
            </div>
            {
                editable && (
                    <div className="card__item__actions">
                        <ButtonCircle onClick={() => onUpdateBgItem()}><EditIcon/></ButtonCircle>
                        <ButtonCircle onClick={() => onItemDelete()}><DeleteIcon/></ButtonCircle>
                    </div>
                )
            }
        </div>
    );
};

export default RmJobs;